import { render, staticRenderFns } from "./ProductsShell.vue?vue&type=template&id=04ed46f6&"
import script from "./ProductsShell.vue?vue&type=script&lang=js&"
export * from "./ProductsShell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports